<template>
    <div class="app-loader-container">
        <div :class="['app-loader', type]">
            <span></span>
        </div>
        <div class="app-loader-message" v-if="message">{{ message }}</div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'loader-spin'
        },
        message: {
            type: String,
            default: null
        }
    }
}
</script>
